import React from 'react';
import List from '../List';

function MultiList({ ...props }) {
    return <List {...props} isMulti={true} />;
}

export default MultiList;
